import classNames from "classnames";
export var defaultButtonRootClasses = classNames('__button_content');
export var defaultCenterClasses = classNames('__button__content_center');
export var defaultLeftClasses = classNames('__button__content_left');
export var defaultRightClasses = classNames('__button__content_right');
export var defaultItemClasses = classNames('__button__content_item');
export var LabelSize = {
    small: 'x-small',
    medium: 'xx-small',
    large: 'normal',
};
export var IconSize = {
    small: 16,
    medium: 18,
    large: 20,
};
